
export default vm => {
  return [
    {
      labelWidth: 95,
      data: [
        {
          name: "所属业务员",
          key: "agentId",
          value: "",
          type: 6,
          arr: [],
          rules: [
            {
              required: true,
              message: "请选择"
            }
          ],
        },
        {
          name: "分配原因",
          key: "reason",
          value: "",
          type: 1,
          modelType: 'textarea',
          clearable: true,
          maxlength: 50,
          showWordLimit: true,
        }
      ],
    }
  ]
}